var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportsBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6V7.5C12 7.775 12.225 8 12.5 8H22.5C22.775 8 23 7.775 23 7.5V6M12 16V17.5C12 17.775 12.225 18 12.5 18H22.5C22.775 18 23 17.775 23 17.5V16M8.5 4.5L4.4165 9L1.5 6.5M2 20L8 14M2 14L8 20",
    stroke: "#3545DE",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsBlue);
export default __webpack_public_path__ + "static/media/reportsBlue.b4dfbb540d2ac8cc150aec58eecb81bf.svg";
export { ForwardRef as ReactComponent };